import { useEffect, useState } from 'react';
import { ChildrenElements } from 'utils/interfaces/commonInterfacesAndTypes';
import LocationContext from './location-context';
import { Location, LocationDto } from 'utils/interfaces/place';
import axios from 'axios';
import { GET_LOCATION } from 'constants/routes';

const geolocationOptions: PositionOptions = {
   enableHighAccuracy: false,
   timeout: 10 * 60 * 1000,
   maximumAge: 24 * 60 * 60 * 1000,
};

const LocationContextProvider = ({ children }: ChildrenElements) => {
   const [location, setLocation] = useState<Location>({ countryCode: '' });

   useEffect(() => {
      const fetchLocation = () => {
         navigator.geolocation.getCurrentPosition(
            position => {
               const { latitude, longitude } = position.coords;
               axios
                  .get<LocationDto>(GET_LOCATION, {
                     params: {
                        lat: latitude,
                        lon: longitude,
                     },
                  })
                  .then(res => {
                     const locationObj = { countryCode: res.data.address.country_code };
                     setLocation(locationObj);
                  });
            },
            () => undefined,
            geolocationOptions,
         );
      };

      fetchLocation();
   }, []);

   return <LocationContext.Provider value={{ location }}>{children}</LocationContext.Provider>;
};

export default LocationContextProvider;
